/**
 * CSS-level style tokens for consistent visual properties across components.
 *
 * NOTE: These values are initial defaults — they should be validated with the
 * design team and may be promoted to theme-configurable tokens in the future.
 */

/** Border width used by input-like components. Structural invariant — unlikely to vary by theme. */
// TODO(design-token): validate with design team
export const borderWidth = {
  sm: '1px',
  md: '2px',
} as const;

/** Transition presets for interactive states. Structural invariant — unlikely to vary by theme. */
// TODO(design-token): validate with design team
export const transition = {
  fast: '0.1s ease-in-out',
  normal: '0.2s ease-in-out',
} as const;

/** Focus ring styling applied on :focus-visible. Structural invariant — unlikely to vary by theme. */
// TODO(design-token): validate with design team
export const focusRing = {
  width: '2px',
  offset: '2px',
} as const;

/**
 * Modal overlay defaults.
 * TODO(theme): opacity may differ between light/dark themes — promote to Emotion
 * theme token once ThemeDefinition supports non-color/non-dimension values.
 */
// TODO(design-token): validate with design team
export const overlay = {
  opacity: 0.56,
} as const;

/**
 * Box-shadow presets.
 * TODO(theme): shadow values may differ between light/dark themes — promote to
 * Emotion theme token once ThemeDefinition supports arbitrary CSS values.
 */
// TODO(design-token): validate with design team
export const shadow = {
  dropdown: '0 4px 12px rgba(0, 0, 0, 0.15)',
} as const;
